import CommodityTrading from '@/service/CommodityTrading.js';
import { getDataGoldPrice, getDataGoldPriceBAC } from '@/service/dataGoldPrice.js';
import { getDataExchangeRate, getDataGoldCodeTable, getDataPriceCode } from '@/service/dataPriceCode';
import { SignalRService } from '@/service/signalrService';
import { defineStore } from 'pinia';
import API from '@/api/api-main';

const ServiceTrading = new CommodityTrading();
const signalRService = new SignalRService();

/** Đóng / làm mới tab hóa đơn: nhả mã voucher đang giữ chỗ theo tab (lỗi mạng thì để tự hết hạn 30 phút). */
const releaseVoucherHold = (tab) => {
    const key = tab?.payload?.voucherHoldKey;
    if (key) API.add(`EVoucherRedeem/release?holdKey=${key}`, {}).catch(() => {});
};

export const transaction = defineStore('transaction', {
    state: () => ({
        data: [ServiceTrading.default_transaction()],
        active: 0,
        exchangeRate: 0,
        goldPrices: [],
        goldPriceBAC: [],
        goldCodeTable: [],
        priceCode: [],
        // Tăng giá trị này để yêu cầu mở popup cập nhật khách hàng (SearchCustomer lắng nghe)
        openCustomerEditNonce: 0,
        // Chốt giữ chỗ: đảm bảo chỉ 1 instance SearchCustomer mở popup (tránh bật 2 lần khi mở nhiều tab)
        customerDialogClaimed: false
    }),

    getters: {
        async fetchGoldPrices() {
            signalRService.start();
            signalRService.on('ReceiveMessage', (data) => {
                if (data.type == 'GoldNew') this.goldPrices = data.goldPrices[0];
                if (data.type == 'PriceCodeNew') this.fetchPriceCode();
                if (data.type == 'GoldPriceBACNew') this.fetchGoldPriceBAC();
                if (data.type == 'ExchangeRateNew') this.fetchExchangeRate();
            });
            const responseGold = await getDataGoldPrice();
            this.goldPrices = responseGold;
        },
        async fetchPriceCode() {
            const response = await getDataPriceCode();
            this.priceCode = { name: 'PriceCode', priceCodes: response.priceCodes, priceCodeTable: response.priceCodeTable };
        },
        async fetchGoldPriceBAC() {
            const response = await getDataGoldPriceBAC();
            this.goldPriceBAC = response;
        },
        async fetchGoldCodeTable() {
            const response = await getDataGoldCodeTable();
            this.goldCodeTable = response;
        },
        async fetchExchangeRate() {
            const response = await getDataExchangeRate();
            this.exchangeRate = response;
        }
    },
    actions: {
        ADD_ARINVOICE() {
            const index = this.data.filter((e) => e.type === 'HOA_DON').length + 1;
            this.data.push(ServiceTrading.getInvoice(index));
            this.active = this.data.length - 1;
        },
        ADD_APINVOICE() {
            const index = this.data.filter((e) => e.type === 'MUA_HANG').length + 1;
            this.data.push(ServiceTrading.getPurchase(index));
            this.active = this.data.length - 1;
        },

        ADD_EXCHANGE() {
            const index = this.data.filter((e) => e.type === 'DOI_HANG').length + 1;
            this.data.push(ServiceTrading.getExchange(index));
            this.active = this.data.length - 1;
        },
        ADD_APIORDER() {
            const index = this.data.filter((e) => e.type === 'DAT_HANG').length + 1;
            this.data.push(ServiceTrading.getOrder(index));
            this.active = this.data.length - 1;
        },
        ADD_ARINVOICE_JEWELRY() {
            const index = this.data.filter((e) => e.type === 'HOA_DON_VTS').length + 1;
            this.data.push(ServiceTrading.getInvoiceJewelry(index));
            this.active = this.data.length - 1;
        },
        ADD_APIORDER_JEWELRY() {
            const index = this.data.filter((e) => e.type === 'DAT_HANG_VTS').length + 1;
            this.data.push(ServiceTrading.getOrderJewelry(index));
            this.active = this.data.length - 1;
        },
        ADD_EXCHANGE_JEWELRY() {
            const index = this.data.filter((e) => e.type === 'DOI_TRA_HANG_VTS').length + 1;
            this.data.push(ServiceTrading.getExchangeJewery(index));
            this.active = this.data.length - 1;
        },
        ADD_APINVOICE_JEWELRY() {
            const index = this.data.filter((e) => e.type === 'MUA_HANG_VTS').length + 1;
            this.data.push(ServiceTrading.getPurchaseJewery(index));
            this.active = this.data.length - 1;
        },
        ADD_GUARANTEE() {
            const index = this.data.filter((e) => e.type === 'BAO_HANH').length + 1;
            this.data.push(ServiceTrading.getGuarantee(index));
            this.active = this.data.length - 1;
        },
        ADD_ASSESSMENT() {
            const index = this.data.filter((e) => e.type === 'KIEM_DINH').length + 1;
            this.data.push(ServiceTrading.getAssessment(index));
            this.active = this.data.length - 1;
        },
        REMOVE_TRANSACTION(id, type, all = false) {
            if (all) {
                this.data.forEach(releaseVoucherHold);
                this.data = [ServiceTrading.default_transaction()];
                this.active = 0;
                return;
            }
            const index = this.data.findIndex((e) => e.id == id && e.type == type);
            if (index != -1) {
                releaseVoucherHold(this.data[index]);
                this.data.splice(index, 1);
                this.active = this.data.length - 1;
            }
        },
        RESET_INVOICE() {
            this.data = [ServiceTrading.default_transaction()];
        },

        CLEAR_DATA(index, id) {
            // const id = index || 1
            releaseVoucherHold(this.data[index]);
            if (this.data[index].type == 'HOA_DON') {
                this.data[index] = ServiceTrading.getInvoice(id);
            }
            if (this.data[index].type == 'HOA_DON_VTS') {
                this.data[index] = ServiceTrading.getInvoiceJewelry(id);
            }
            if (this.data[index].type == 'MUA_HANG') {
                this.data[index] = ServiceTrading.getPurchase(id);
            }
            if (this.data[index].type == 'DOI_HANG') {
                this.data[index] = ServiceTrading.getExchange(id);
            }
            if (this.data[index].type == 'DAT_HANG') {
                this.data[index] = ServiceTrading.getOrder(id);
            }
            if (this.data[index].type == 'DAT_HANG_VTS') {
                this.data[index] = ServiceTrading.getOrderJewelry(id);
            }
            if (this.data[index].type == 'MUA_HANG_VTS') {
                this.data[index] = ServiceTrading.getPurchaseJewery(id);
            }
            if (this.data[index].type == 'DOI_TRA_HANG_VTS') {
                this.data[index] = ServiceTrading.getExchangeJewery(id);
            }
            if (this.data[index].type == 'BAO_HANH') {
                this.data[index] = ServiceTrading.getWarranteeJewery(id);
            }
            if (this.data[index].type == 'KIEM_DINH') {
                this.data[index] = ServiceTrading.getAssessment(id);
            }
        },

        SET_ACTIVE(idex) {
            this.active = idex;
        },

        SET_PRODUCT() {
            const data = this.data[this.active];
            data.Products = data.Products.map((e) => {
                const priceCodeTableId = this.priceCode.priceCodeTable.find((table) => table.priceCodeTableType == e.priceList)?.id || null;
                return { ...e, priceCodeTableId: priceCodeTableId };
            });
            if (data.type == 'HOA_DON') ServiceTrading.setProductInvoice(data, this.goldPrices);
            if (data.type == 'MUA_HANG') ServiceTrading.setProductPurchase(data, this.goldPrices);
            if (data.type == 'DOI_HANG') ServiceTrading.setProductExchange(data, this.goldPrices);
            if (data.type == 'DAT_HANG') ServiceTrading.setProductOrder(data, this.goldPrices);
            if (data.type == 'HOA_DON_VTS') ServiceTrading.setProductInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
            if (data.type == 'DOI_TRA_HANG_VTS') ServiceTrading.setProductInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
            if (data.type == 'MUA_HANG_VTS') ServiceTrading.setProductPurchaseJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable, this.goldCodeTable, this.goldPriceBAC);
            if (data.type == 'DAT_HANG_VTS') ServiceTrading.setProductOrderJewelry(data, this.goldPrices);
            if (data.type == 'BAO_HANH') ServiceTrading.setProductWarantyJewelry(data, this.goldPrices);
            if (data.type == 'KIEM_DINH') ServiceTrading.setProductWarantyJewelry(data, this.goldPrices);
        },

        SET_PROMOTION() {
            const data = this.data[this.active];
            if (data.type == 'HOA_DON_VTS') ServiceTrading.setPromotionInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
            if (data.type == 'DAT_HANG_VTS') ServiceTrading.setPromotionInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
            if (data.type == 'DOI_TRA_HANG_VTS') ServiceTrading.setPromotionInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
        },

        SET_RECIPE() {
            const data = this.data[this.active];
            if (data.type == 'DOI_TRA_HANG_VTS') ServiceTrading.setRecipeInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
        },
        SET_SERIAL() {
            const data = this.data[this.active];
            if (data.type == 'DAT_HANG_VTS') ServiceTrading.setSerialOrderJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
        },
        UPDATE_PRODUCT() {
            const data = this.data[this.active];
            if (data.type == 'DAT_HANG_VTS') ServiceTrading.updateProductInvoiceJewelry(data, this.goldPrices, this.priceCode.priceCodes, this.priceCode.priceCodeTable);
        },
        REQUEST_EDIT_CUSTOMER() {
            // Reset chốt giữ chỗ rồi phát tín hiệu để chỉ 1 instance SearchCustomer mở popup
            this.customerDialogClaimed = false;
            this.openCustomerEditNonce++;
        },
        SET_CUSTOMER() {
            const data = this.data[this.active];
            data.payload.cardCode = data.Customer.bpCode;
            data.payload.cardName = data.Customer.cardName;
            data.payload.cardId = data.Customer.id;
            data.payload.citizenId = data.Customer?.citizenId;
            data.payload.nationality = data.Customer?.nationality || '';
            data.payload.dateOfBirth = data.Customer?.dateOfBirth || null;
            data.payload.phone = data.Customer?.phone || '';
            data.payload.typeDoc = data.Customer?.typeDoc || '';
            data.payload.cityName = data.Customer?.cityName || '';
            data.payload.country = data.Customer?.country || '';
            // Set địa chỉ
            const dataCheck = data.Customer.crD1.find((e) => e.default === 'Y') != undefined ? data.Customer.crD1.find((e) => e.default === 'Y') : null;
            data.payload.address = {
                id: 0,
                fatherId: 0,
                address: !dataCheck ? data.Customer?.address || '' : dataCheck.address,
                cityId: !dataCheck ? data.Customer?.cityId || 0 : dataCheck.cityId,
                cityName: !dataCheck ? data.Customer?.cityName || '' : dataCheck.cityName,
                locationId: !dataCheck ? data.Customer?.locationId || 0 : dataCheck.locationId,
                locationName: !dataCheck ? data.Customer?.locationName || '' : dataCheck.locationName,
                areaId: !dataCheck ? data.Customer?.areaId || 1 : dataCheck.areaId,
                areaName: !dataCheck ? data.Customer?.areaName || '' : dataCheck.areaName,
                email: !dataCheck ? data.Customer?.email || '' : dataCheck.email,
                phone: !dataCheck ? data.Customer?.phone || '' : dataCheck.phone,
                person: !dataCheck ? data.Customer?.person || '' : dataCheck.person,
                note: !dataCheck ? data.Customer?.note || '' : dataCheck.note
            };
        },

        /**
         * Ghi danh sách tag NFC cho một dòng hàng.
         *
         * Phải ghi vào CẢ `Products` lẫn `payload.itemDetail`: ô quét hiển thị trên
         * `itemDetail`, nhưng `SET_PRODUCT` dựng lại `itemDetail` từ `Products` mỗi
         * lần thêm/xoá hàng — chỉ ghi một chỗ thì tag quét xong sẽ biến mất.
         *
         * Hai mảng luôn song song 1-1 (`itemDetail = Products.map(...)`, và
         * `REMOVE_PRODUCT` xoá đồng thời ở cả hai), nên khớp được bằng vị trí.
         */
        SET_LINE_NFC_UIDS(line, uids) {
            const data = this.data[this.active];
            line.nfcUids = uids;

            const index = data.payload.itemDetail?.indexOf(line) ?? -1;
            if (index !== -1 && data.Products[index]) data.Products[index].nfcUids = uids;
        },

        REMOVE_PRODUCT(id) {
            if (this.data[this.active].payload.id) {
                return false;
            }
            this.data[this.active].Products = this.data[this.active].Products.filter((e) => e.id != id);
            this.data[this.active].payload.itemDetail = this.data[this.active].payload.itemDetail.filter((e) => e.itemId != id);
        },
        REMOVE_PRODUCT_JEWELRY(data, serial) {
            if (serial) {
                this.data[this.active].payload.itemDetail = this.data[this.active].payload.itemDetail.filter((e) => e.serialBatchNumber != serial);
                this.data[this.active].Products = this.data[this.active].Products.filter((e) => e.serial?.serialNumber != serial);
            } else {
                this.data[this.active].Products = this.data[this.active].Products.filter((e) => e.id != data.itemId);
                this.data[this.active].payload.itemDetail = this.data[this.active].payload.itemDetail.filter((e) => e.itemId != data.itemId);
            }
        },
        REMOVE_PRODUCT_GUARANTEE(index) {
            this.data[this.active].Products = this.data[this.active].Products.filter((e) => e.index != index);
            this.data[this.active].payload.itemDetail = this.data[this.active].payload.itemDetail.filter((e) => e.index != index);

            // Cập nhật lại index theo thứ tự
            this.data[this.active].Products.forEach((item, idx) => {
                item.index = idx;
            });
            this.data[this.active].payload.itemDetail.forEach((item, idx) => {
                item.index = idx;
            });
        },
        REMOVE_PRODUCT_INDEX(index, itemId) {
            this.data[this.active].Products = this.data[this.active].Products.filter((e) => e.index != index);
            this.data[this.active].payload.itemDetail = this.data[this.active].payload.itemDetail.filter((e) => e.index != index);

            // Cập nhật lại index theo thứ tự
            this.data[this.active].Products.forEach((item, idx) => {
                item.index = idx;
            });
            this.data[this.active].payload.itemDetail.forEach((item, idx) => {
                item.index = idx;
            });
        }
    }
});
